import { render, staticRenderFns } from "./RegionsForRegister.vue?vue&type=template&id=2d74ce8f&scoped=true&"
import script from "./RegionsForRegister.vue?vue&type=script&lang=js&"
export * from "./RegionsForRegister.vue?vue&type=script&lang=js&"
import style0 from "./RegionsForRegister.vue?vue&type=style&index=0&id=2d74ce8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d74ce8f",
  null
  
)

export default component.exports